import { Component, OnInit } from '@angular/core';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { PdaPagamento } from './models/pda-pagamenti';
import { GestionePagamentiService } from './services/gestione-pagamenti.service';
import { PdaListaPagamentiRequest } from './models/pda-lista-pagamenti-request';
import { GeneraAvvisoModalComponent } from './components/genera-avviso-modal/genera-avviso-modal/genera-avviso-modal.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { PdaGeneraAvvisoRequest } from './models/pda-genera-avviso-request';
import { PagamentiDetailComponent } from './components/pagamenti-detail/pagamenti-detail/pagamenti-detail.component';
import { DownloadAvvisoDisclaimerComponent } from './components/download-avviso-disclaimer/download-avviso-disclaimer.component';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { PdaDownloadAvvisoRequest } from './models/pda-download-avviso-request';
import { PdaDownloadRicevutaRequest } from './models/pda-download-ricevuta-request';
import { PdaAuthService } from '../../utils/Service/pda-auth.service';

@Component({
  selector: 'app-gestione-pagamenti',
  templateUrl: './gestione-pagamenti.component.html',
  styleUrls: ['./gestione-pagamenti.component.css'],
  host: { "[attr.id]": "'content'" },
})
export class GestionePagamentiComponent implements OnInit {

  urlCancelleria: string =
    "/" + UrlSettingsCore.URL_CANCELLERIA_TELEMATICA + "/";

  payments: PdaPagamento[];
  currentSearchReq: PdaListaPagamentiRequest;
  hasSearched: boolean = false;


  constructor(private viewManager: ViewManagerService,
    private pagamentiService: GestionePagamentiService,
    private dialog: DialogService,
    private modalNotifyService: ModalNotifyService,
    private pdaAuthService: PdaAuthService
  ){

  }

  ngOnInit(): void {
    this.viewManager.svuotaMenu();
  }

  async getListaPagamenti(req: PdaListaPagamentiRequest){
    this.currentSearchReq = req;
    req.token = await this.pdaAuthService.getPdaToken();
    this.pagamentiService.getListaPagamenti(req).subscribe((res: PdaPagamento[]) => {
      this.payments = res;
      this.hasSearched = true;
    });
  }

  async generaAvviso(req: PdaGeneraAvvisoRequest){
    req.token = await this.pdaAuthService.getPdaToken();
    this.pagamentiService.generaAvviso(req).subscribe((avviso) => {
        this.getListaPagamenti(this.currentSearchReq);
        const ref = this.dialog.open(DownloadAvvisoDisclaimerComponent, {
          data: {
            style: {
              width: '30%',
            },
            title: 'Download Avviso di Pagamento',
          }
        });
        ref.afterClosed.subscribe((event) => {
          if(!event || event.closeEvent) return;
          if(event.modalEvent === true) {
            let downloadReq: PdaDownloadAvvisoRequest = new PdaDownloadAvvisoRequest();
            downloadReq.numeroAvviso = avviso.numeroAvviso;
            downloadReq.token = req.token;
            this.pagamentiService.downloadAvviso(downloadReq).subscribe();
          }
        });
      }
    );
  }

  async downloadAvviso(req: PdaDownloadAvvisoRequest){
    req.token = await this.pdaAuthService.getPdaToken();
    this.pagamentiService.downloadAvviso(req).subscribe();
  }

  async downloadRicevuta(req: PdaDownloadRicevutaRequest){
    req.token = await this.pdaAuthService.getPdaToken();
    this.pagamentiService.downloadRicevuta(req).subscribe();
  }

  onRefresh(event: any){
    this.getListaPagamenti(this.currentSearchReq);
  }

  async onGeneraAvviso(){
    const ref = this.dialog.open(GeneraAvvisoModalComponent, {
      data: {
        style: {
          width: '50%',
          overflow: false
        },
        title: 'Genera Avviso di Pagamento Telematico',
      }
    });
    ref.afterClosed.subscribe((event) => {
      if(!event || event.closeEvent) return;
      else{
        if(event.modalEvent == 'submit' && event.request){
          this.generaAvviso(event.request);
        }
      }
    })
  }

}
